module.exports = __webpack_public_path__ + "img/img.4922dbb3.png";